<template>
  <zj-layout-container>
    <zj-layout-main>
      <div class="dataBox dataBox-weather">
        <div class="weather-tabbody weather-detail clearfix">
          <div
            class="weather-realtime clearfix"
            style="background-color: #021132"
          >
            <div v-bind:class="'weather-icon weather-icon-' + d.realtime.img">
              <i
                v-bind="
                  d.realtime.weather +
                  ',' +
                  d.city +
                  '（来源：' +
                  d.source +
                  '）'
                "
              ></i>
            </div>
            <div class="weather-temp">
              <span>{{ d.realtime.temp }}℃</span>
            </div>
            <div class="weather-pm25">
              <span title="空气质量"
                >{{ d.realtime.aqi }} {{ d.realtime.aqa }}</span
              >
            </div>
            <div class="weather-humi">
              <i></i><span>湿度</span><span>{{ d.realtime.sd }}%</span>
            </div>
            <div class="weather-wind">
              <i></i><span>{{ d.realtime.wd }}</span
              ><span>{{ d.realtime.ws }}</span>
            </div>
          </div>
          <div class="echart negative_oxygen_ion">
            <div class="echart_wrapper w100_h50 chart_part"></div>
            <div class="echart_wrapper w100_h50 chart_part"></div>
          </div>
        </div>
      </div>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import MyApis from "../../apis";

export default {
  name: "ZJEcologicaldata",
  controller: "UI",
  action: "Ecologicaldata",
  props: {
    query: {
      city: {
        type: String,
        required: true,
        default: "南湖风景区",
      },
      cityname: {
        type: String,
        default: "",
      },
    },
  },
  data() {
    return {
      d: {
        cityid: "",
        city: "",
        sourceid: "",
        source: "",
        time: new Date(),
        realtime: {},
        indexes: [],
        hour24: [],
        day7: [],
      },
      ChartStyle: {
        FontSize: {
          Title: 18,
          Tooltip: 18,
        },
      },
    };
  },
  created: function () {},
  mounted: function () {
    this.getWeather();
    this.getNegativeOxygenIon();
  },
  methods: {
    getWeather: function () {
      let searchInfo = {
        City: this.query.city || "",
        Source: "",
      };

      new MyApis.WeatherApi()
        .GetWeather(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.d = r;
        })
        .catch((e) => {
          console.log(this, e);
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    getNegativeOxygenIon: function () {
      let that = this;
      let searchInfo = {
        SysCode: "BigDataMangeLaoShan",
        Key: "NegativeOxygenIon",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          that.drawNegativeOxygenIon(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    drawNegativeOxygenIon: function (responseData) {
      var that = this;
    
      // eslint-disable-next-line no-undef
      var target = $(".negative_oxygen_ion")[0];

      // eslint-disable-next-line no-undef
      $.each(responseData, function (index, item) {
          that.drawNegativeOxygenIonChart(
            // eslint-disable-next-line no-undef
            $(target).find(".chart_part")[index],
            item
          );
        });
    },
    drawNegativeOxygenIonChart: function (target, responseData) {
      var that = this;
     
      // eslint-disable-next-line no-undef
      var chart = echarts.init(target);

      var pm25data = [];
      var humiditydata = [];
      for (var i = 0; i < 4; i++) {
        pm25data.push(
          {
            value: 10,
            name: "",
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderColor: "#00ffff",
                shadowColor: "#00ffff",
                color: "#00ffff",
              },
            },
          },
          {
            value: 2,
            name: "",
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                color: "rgba(0, 0, 0, 0)",
                borderColor: "rgba(0, 0, 0, 0)",
                borderWidth: 0,
              },
            },
          }
        );

        humiditydata.push(
          {
            value: 10,
            name: "",
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderColor: "#ffffff",
                shadowColor: "#ffffff",
                color: "#ffffff",
              },
            },
          },
          {
            value: 2,
            name: "",
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                color: "rgba(0, 0, 0, 0)",
                borderColor: "rgba(0, 0, 0, 0)",
                borderWidth: 0,
              },
            },
          }
        );
      }

      var echartData = responseData;

      var pointDatas = [];
      var pointColor = "#17E991";

      function createPoints(count) {
        var points = [];
        for (var i = 0; i < count; i++) {
          points.push({
            id: i,
            itemStyle: {
              normal: {
                color: pointColor,
              },
            },
          });
        }
        return points;
      }

      pointDatas = createPoints(20);

      var series = [],
        titles = [];

   
        var trendCategorys = [],
          trendValues = [];

        var curHour = new Date().getHours();

        // eslint-disable-next-line no-undef
        $.each(responseData.NegativeOxygenIonTrend, function (index, item) {
          trendCategorys.push(item.name);
          if (item.name <= curHour) {
            trendValues.push(item.value);
          }
        });

        titles.push({
          text: "负氧离子\n(" + responseData.Name + ")",
          left: "25%",
          top: "8%",
          textAlign: "center",
          textStyle: {
            fontWeight: "normal",
            fontSize: 22,
            color: pointColor,
            textAlign: "center",
          },
        });

        // 负氧离子
        series.push({
          name: "负氧离子中心数值",
          type: "pie",
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          center: ["25%", "50%"],
          radius: ["0%", "0%"],
          itemStyle: {
            normal: {
              color: "rgba(0,0,0, 0)",
            },
          },
          data: [
            {
              value: 10,
              name: "",
            },
          ],
          label: {
            normal: {
              // eslint-disable-next-line no-unused-vars
              formatter: function (params) {
                var number = echartData.NegativeOxygenIon;
                return "{number|" + number + "}个";
              },
              position: "center",
              textStyle: {
                fontSize: that.ChartStyle.FontSize.Title,
                fontWeight: "bold",
                color: pointColor,
              },
              rich: {
                number: {
                  color: pointColor,
                  fontSize: that.ChartStyle.FontSize.Title,
                  padding: [0, 0],
                  fontWeight: "bold",
                },
                unit: {
                  color: pointColor,
                  fontSize: that.ChartStyle.FontSize.Title * 0.9,
                  padding: [20, 0, 0, 0],
                  fontWeight: "bold",
                  verticalAlign: "bottom",
                },
                level: {
                  color: pointColor,
                  fontSize: that.ChartStyle.FontSize.Title * 0.9,
                  padding: [0, 0, 0, 0],
                  fontWeight: "bold",
                  verticalAlign: "bottom",
                },
              },
            },
          },
        });

        series.push({
          name: "外层点状图",
          type: "graph",
          layout: "circular",
          animation: false,
          symbolSize: 10,
          left: "0%",
          top: "25%",
          width: "50%",
          height: "50%",
          data: pointDatas,
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              color: pointColor,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
          },
        });

        series.push({
          name: "中间层点状图",
          type: "graph",
          layout: "circular",
          animation: false,
          symbolSize: 9,
          left: "5.5%",
          top: "30.5%",
          width: "39%",
          height: "39%",
          data: pointDatas,
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              color: pointColor,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
          },
        });

        series.push({
          name: "内层点状图",
          type: "graph",
          layout: "circular",
          animation: false,
          symbolSize: 8,
          left: "11%",
          top: "36%",
          width: "28%",
          height: "28%",
          data: pointDatas,
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              color: pointColor,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
          },
        });

        // 温度
        series.push({
          name: "温度离散环形图",
          type: "pie",
          clockWise: false,
          radius: ["35%", "38%"],
          center: ["60%", "25%"],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          data: pm25data,
        });
        // 温度值
        series.push({
          name: "温度中心数值",
          type: "pie",
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          center: ["60%", "25%"],
          radius: ["0%", "0%"],
          itemStyle: {
            normal: {
              color: "rgba(0,0,0, 0)",
            },
          },
          data: [
            {
              value: 10,
              name: "",
            },
          ],
          label: {
            normal: {
              // eslint-disable-next-line no-unused-vars
              formatter: function (params) {
                var number = echartData.Temperature;
                return "温度\n{number|" + number + "}℃";
              },
              position: "center",
              textStyle: {
                fontSize: that.ChartStyle.FontSize.Title,
                fontWeight: "bold",
                color: pointColor,
              },
              rich: {
                number: {
                  color: pointColor,
                  fontSize: that.ChartStyle.FontSize.Title,
                  padding: [0, 0],
                  fontWeight: "bold",
                },
                level: {
                  color: pointColor,
                  fontSize: that.ChartStyle.FontSize.Title,
                  padding: [0, 0, 20, 0],
                  fontWeight: "bold",
                  verticalAlign: "bottom",
                },
              },
            },
          },
        });
        //湿度
        series.push({
          name: "湿度离散环形图",
          type: "pie",
          clockWise: false,
          radius: ["35%", "38%"],
          center: ["85%", "25%"],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          data: humiditydata,
        });
        //湿度值
        series.push({
          name: "湿度中心数值",
          type: "pie",
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          center: ["85%", "25%"],
          radius: ["0%", "0%"],
          itemStyle: {
            normal: {
              color: "rgba(0,0,0, 0)",
            },
          },
          data: [
            {
              value: 10,
              name: "",
            },
          ],
          label: {
            normal: {
              // eslint-disable-next-line no-unused-vars
              formatter: function (params) {
                var number = echartData.Humidity;
                return "湿度\n{number|" + number + "} %RH";
              },
              position: "center",
              textStyle: {
                fontSize: that.ChartStyle.FontSize.Title,
                fontWeight: "bold",
                color: "#ffffff",
              },
              rich: {
                number: {
                  color: "#ffffff",
                  fontSize: that.ChartStyle.FontSize.Title,
                  padding: [0, 0],
                  fontWeight: "bold",
                },
                level: {
                  color: "#ffffff",
                  fontSize: that.ChartStyle.FontSize.Title,
                  padding: [0, 0, 20, 0],
                  fontWeight: "bold",
                  verticalAlign: "bottom",
                },
              },
            },
          },
        });

        series.push({
          name: "最高气温",
          type: "line",
          data: trendValues,
          markPoint: {
            label: {
              normal: {
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0.3)", // #2748b7
              },
            },
            data: [
              {
                type: "max",
                name: "最大值",
                label: {
                  color: "red",
                },
                itemStyle: {
                  color: "red",
                },
              },
              { type: "min", name: "最小值" },
            ],
          },
          markLine: {
            precision: 0,
            label: {
              normal: {
                position: "end",
                color: pointColor,
              },
            },
            lineStyle: {
              normal: {
                color: pointColor,
              },
            },
            data: [{ type: "average", name: "平均值" }],
          },
        });

        var option = {
          //backgroundColor: '#04243E',
          tooltip: {
            show: false,
          },
          legend: {
            show: false,
          },
          toolbox: {
            show: false,
          },
          title: titles,
          grid: {
            width: "45%",
            height: 100,
            right: 35,
            bottom: 40,
          },
          xAxis: [
            {
              name: "时",
              nameTextStyle: {
                fontSize: that.ChartStyle.FontSize.Axis,
              },
              type: "category",
              boundaryGap: false,
              data: trendCategorys,
              axisLabel: {
                color: "#fff",
                fontSize: "16",
                formatter: "{value}时",
              },
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
            },
          ],
          yAxis: [
            {
              name: "个",
              nameTextStyle: {
                fontSize: that.ChartStyle.FontSize.Axis,
              },
              type: "value",
              axisLabel: {
                color: "#fff",
                fontSize: "16",
              },
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
            },
          ],
          series: series,
        };
        chart.setOption(option);
    },
  },
};
</script>
